import * as React from 'react';
import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { track } from '@components/tracking';

import { api } from '../api';
import { VideoPage } from '../components/VideoPage';

export const HighlightReelPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { token } = useParams() as { token: string };

  const { data, isLoading } = api.useGetHighlightReelQuery({ token });

  useEffect(() => {
    if (data) {
      track('viewed_highlight_reel', {
        layout: 'public',
        artifact_type: 'highlight_reel',
        is_creator: false,
        is_guest: true
      });
    }
  }, [data]);

  return (
    <VideoPage
      isLoading={isLoading}
      title={data?.title || 'Untitled highlight reel'}
      subtitle={data?.subtitle}
      name={data?.creator?.name}
      date={data && new Date(data.created_at)}
      playbackUrls={data?.playback_urls}
      signUpUrl={`/users/sign_up?asset_referrer=${token}`}
    />
  );
};
